import { ref, onMounted, onUnmounted } from 'vue';

export function useViewport() {
  const windowWidth = ref(window.visualViewport ? window.visualViewport.width : window.innerWidth);
  const windowHeight = ref(window.visualViewport ? window.visualViewport.heigth : window.innerHeight);

  const breakpoints = {
    tablet: 700,
    desktop: 1000
  };

  const isMobile = ref(windowWidth.value < breakpoints.tablet);
  const isTablet = ref(windowWidth.value >= breakpoints.mobile && windowWidth.value < breakpoints.desktop);
  const isDesktop = ref(windowWidth.value >= breakpoints.desktop);

  const updateViewport = () => {
    windowWidth.value = window.visualViewport ? window.visualViewport.width : window.innerWidth;
    windowHeight.value = window.visualViewport ? window.visualViewport.height : window.innerHeight;

    isMobile.value = windowWidth.value < breakpoints.tablet;
    isTablet.value = windowWidth.value >= breakpoints.tablet && windowWidth.value < breakpoints.desktop;
    isDesktop.value = windowWidth.value >= breakpoints.desktop;
  };

  onMounted(() => {
    window.addEventListener('resize', updateViewport);
    updateViewport();
  });

  onUnmounted(() => {
    window.removeEventListener('resize', updateViewport);
  });

  return {
    windowWidth,
    windowHeight,
    isMobile,
    isTablet,
    isDesktop
  };
}
